import Tabs, { TabsType } from 'components/partials/tabs'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import AgencyGroup from './agency-group'
import TemplateCustomization from './template-customization'
import DetailAgencyGroup from './detail-agency-group'
import ForwardWebhook from './forward-webhook'
import ForwardEmail from './forward-email'
const AgencyGroupManagement = () => {
  const tabs: TabsType = [
    {
      label: 'Agency Group',
      index: 5,
      Component: AgencyGroup,
    },
    {
      label: 'Detail Agency Group',
      index: 6,
      Component: DetailAgencyGroup,
    },
    {
      label: 'Template Customization',
      index: 7,
      Component: TemplateCustomization,
    },
    {
      label: 'Forward Webhook',
      index: 8,
      Component: ForwardWebhook,
    },
    {
      label: 'Forward Email',
      index: 9,
      Component: ForwardEmail,
    },
  ]

  const location = useLocation()
  const [selectedTab, setSelectedTab] = useState<number>(tabs[0].index)

  return (
    <div>
      <Tabs
        needResponsive={true}
        selectedTab={selectedTab}
        carrier={location.state}
        pageName=""
        onClick={setSelectedTab}
        tabs={tabs}
        isShowPath={false}
      />
    </div>
  )
}

export default AgencyGroupManagement
